import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetOrganisationByEntityIdMessages } from './messages';

export interface useGetOrganisationByEntityIdOptions {
  shouldFetch?: boolean;
}

export function useGetOrganisationByEntityId(
  organisationEntityId: string | null | undefined,
  options?: useGetOrganisationByEntityIdOptions,
) {
  const mergedOptions: useGetOrganisationByEntityIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { organisationApi } = usePrivate();

  const results = useSWR(
    organisationApi && mergedOptions.shouldFetch
      ? `/api/Organisation/ByEntityId/${organisationEntityId}`
      : null,
    () => organisationApi?.apiOrganisationByEntityIdGet(organisationEntityId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetOrganisationByEntityIdMessages[
            'useGetOrganisationByEntityId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetOrganisationByEntityId> error fetching organisation.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !organisationApi;

  return { ...results, isLoadingOrValidating };
}
